<template>
    <div class="regist mailSetting">
        <div v-if="showLoading" class="jleague_loader"></div>
        <div v-if="!showLoading">
            <h2 v-if="selectedClubTeam">
                <img :src="emblemImagePath(selectedClubTeam().emblemImg)" alt="">
                {{ selectedClubTeam().teamName }}
            </h2>
            <div v-if="filteredPlayerList.length > 0">
                <div v-for="(selectedPlayerId, index) in selectedPlayerIds" :key="index" class="player-selection">
                    <span class="label">{{ index + 1 }}人目</span>
                    <span class="select player-select expanded">
                        <select v-model="selectedPlayerIds[index]" @change="onPlayerChange">
                            <option value="null">未設定</option>
                            <option v-for="player in filteredPlayerList" 
                                :key="player.player_id" 
                                :value="player.player_id"
                                :disabled="isPlayerSelected(player.player_id) && !isCurrentSelection(player.player_id, index)">
                                {{ player.position }} {{ player.uniform_number }} {{ player.player_name }}
                            </option>                            
                        </select>
                    </span>
                </div>
            </div>

            <div class="btnSpace duo">
                <button @click="goToClubSelection" type="button" class="return">クラブ選択に戻る</button>
                <button type="submit" @click="updateFavoritePlayers" :disabled="isUpdating">登録</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mixinJleague } from '../../mixin/utility'
export default {
    mixins: [mixinJleague],
    props: {
        selectedClubCode: String,
        filteredPlayerList: Array,
        selectedPlayerIds: Array,
        isUpdating: Boolean,
        clubFavoritePlayerList: Array,
    },
    watch: {
        clubFavoritePlayerList(newVal) {
            this.initializeSelectedPlayers();
        }
    },
    data() {
        return {
            clubCode: this.selectedClubCode,
            playerMaster: { "player_master": [] },
            showLoading: true,
        };
    },
    async created() {
        try {
            await this.fetchPlayers();
            this.fetchFavoritePlayers();
            this.initializeSelectedPlayers();
        } finally {
            this.showLoading = false;
        }
    },
    computed: {
        filteredPlayerList() {
            try {
                const selectedClub = this.playerMaster["player_master"].find(club => club.club_code === this.clubCode);
                return selectedClub ? selectedClub.player_list : [];
            } catch (error) {
                console.error('Error in filteredPlayerList:', error);
                return [];
            }
        }
    },
    methods: {
        async fetchPlayers() {
            try {
                this.playerMaster["player_master"] = await this.getPlayerMaster(this.clubCode);
            } catch (error) {
                alert(error.message);
                this.goToClubSelection();
            }
        },
        fetchFavoritePlayers() {
            this.$emit('fetch-favorite-players');
        },
        initializeSelectedPlayers() {
            const selectedPlayers = this.clubFavoritePlayerList.map(fav => fav.player_id);
            this.selectedPlayerIds = [...selectedPlayers, ...this.selectedPlayerIds].slice(0, 3);
        },
        selectedClubTeam() {
            return this.getClubTeamByClubCode(this.clubCode);
        },
        emblemImagePath(emblemImg) {
            return 'https://auth2.jleague.jp/emblem/' + emblemImg;
        },
        onPlayerChange() {
            this.selectedPlayerIds = this.selectedPlayerIds.filter(playerId => playerId !== null);
            while (this.selectedPlayerIds.length < 3) {
                this.selectedPlayerIds.push(null);
            }
        },
        goToClubSelection() {
            this.$emit('go-to-club-selection');
        },
        updateFavoritePlayers() {
            this.$emit('update-favorite-players', this.selectedPlayerIds, this.filteredPlayerList);
        },
        isPlayerSelected(playerId) {
            return this.selectedPlayerIds.includes(playerId);
        },
        isCurrentSelection(playerId, index) {
            return this.selectedPlayerIds[index] === playerId;
        },
        
    },
};
</script>
